import { useTranslation } from 'react-i18next';

import { Label, LABEL_TYPE } from '@/components/generic';

import { STATUS_OVERVIEW } from './status-overview-config';

type StatusOverviewProps = {
  isMobileView: boolean;
  statusOverviewData: Record<string, number>;
};

export const StatusOverview = ({ isMobileView, statusOverviewData }: StatusOverviewProps) => {
  const [t] = useTranslation('common');

  return (
    <div className='mt-10 grid grid-cols-7 divide-x divide-dashed divide-blue-100'>
      {STATUS_OVERVIEW.map(({ statusKey, statusIcon: Icon, statusLabelKey }) => (
        <div key={statusKey} className='flex w-full flex-col items-center text-center'>
          <Icon width={40} height={40} />
          <Label type={LABEL_TYPE.H3} text={statusOverviewData[statusKey]} className='mt-2' />
          {!isMobileView && <Label type={LABEL_TYPE.STATUS_LABEL} text={t(statusLabelKey)} />}
        </div>
      ))}
    </div>
  );
};
